import { render, staticRenderFns } from "./NewWalletOffSetting.vue?vue&type=template&id=543762bf"
import script from "./NewWalletOffSetting.vue?vue&type=script&lang=js"
export * from "./NewWalletOffSetting.vue?vue&type=script&lang=js"
import style0 from "./NewWalletOffSetting.vue?vue&type=style&index=0&id=543762bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports